import { Typography } from "@material-ui/core";
import React from "react";
import ErrorText from "../../../app/components/ErrorText";
import ConfirmDialog from "../../../app/components/modals/ConfirmDialog";
import { RequestStateDto } from "../../../app/dtos/RequestStateDto";
import { ColorsEnum } from "../../../app/enums/ColorsEnum";
import { OutreachActivityDto } from "../dtos/OutreachActivityDto";
interface Props {
  requestState: RequestStateDto;
  activity?: OutreachActivityDto;
  onConfirm(): Promise<void>;
}

export const confirmDeleteOutreachActivityDialogId =
  "delete-outreach-activity-dialog";
const ConfirmDeleteOutreachActivityDialog: React.FC<Props> = ({
  onConfirm,
  requestState,
  activity,
}) => {
  const { error, isLoading } = requestState;

  return (
    <ConfirmDialog
      title="Confirm"
      onConfirm={onConfirm}
      modalId={confirmDeleteOutreachActivityDialogId}
      isLoading={isLoading}
      confirmButtonText="Delete Outreach Activity"
      maxWidth="md"
      confirmButtonStyle={{ color: ColorsEnum.Red }}
    >
      <ErrorText error={error?.message} />
      <Typography style={{ marginBottom: "8px" }}>
        Are you sure you want to delete Outreach Activity '{activity?.title}'?
      </Typography>
    </ConfirmDialog>
  );
};

export default ConfirmDeleteOutreachActivityDialog;
